type Props = {
  eyebrow: string;
  title: string;
  subtitle: string;
  updated: string;
  sections: { title: string; body: string }[];
};

export default function LegalLayout({ eyebrow, title, subtitle, updated, sections }: Props) {
  return (
    <div className="bg-kag-bg text-white">
      {/* HERO */}
      <section className="bg-kag-bg">
        <div className="mx-auto w-full max-w-page px-5 sm:px-8 md:px-10 lg:px-[60px] pt-12 sm:pt-16 lg:pt-[85px] pb-10 sm:pb-14 lg:pb-[80px] text-center">
          <p className="font-clash text-kag-eyebrow text-[13px] sm:text-[15px] lg:text-[17px] leading-[1.2] uppercase tracking-[0.18em]">
            {eyebrow}
          </p>
          <h1 className="mt-5 lg:mt-7 font-clash font-medium text-white uppercase text-[40px] sm:text-[60px] md:text-[80px] lg:text-[96px] leading-[0.98] tracking-tight">
            {title}
          </h1>
          <p className="mx-auto mt-6 lg:mt-9 max-w-[820px] font-clash text-[#b9b9b9] text-[14px] sm:text-[16px] lg:text-[18px] leading-[1.5]">
            {subtitle}
          </p>
          <p className="mt-5 font-clash text-[#8e8e8e] text-[12px] sm:text-[13px] uppercase tracking-[0.16em]">
            {updated}
          </p>
        </div>
      </section>

      {/* CONTENT */}
      <section className="bg-white text-[#010f1f]">
        <div className="mx-auto w-full max-w-[920px] px-5 sm:px-8 md:px-10 lg:px-12 py-12 md:py-16 lg:py-[80px]">
          <div className="space-y-10 lg:space-y-12">
            {sections.map((s) => (
              <article key={s.title}>
                <div className="flex items-start gap-3 lg:gap-4">
                  <span className="block bg-kag-red rounded-full mt-2 lg:mt-3 shrink-0 w-[10px] h-[10px] lg:w-[12px] lg:h-[12px]" />
                  <h2 className="font-clash font-semibold text-[#010f1f] text-[20px] sm:text-[24px] lg:text-[28px] leading-[1.15] tracking-tight">
                    {s.title}
                  </h2>
                </div>
                <div className="mt-3 lg:mt-4 pl-5 lg:pl-7 font-clash text-[#3a4654] text-[14px] sm:text-[15px] lg:text-[16px] leading-[1.65] whitespace-pre-line">
                  {s.body}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <div className="h-12 bg-kag-bg" />
    </div>
  );
}
